import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { EventTypes } from 'src/app/core/constants/event-types';
import { UpdateSmsTemplateCommand } from '../../../../core/api/models';
import { CreateSmsTemplateCommand } from '../../../../core/api/models/create-sms-template-command';
import { GetSmsTemplateByIdDto } from '../../../../core/api/models/get-sms-template-by-id-dto';
import { SmsTemplatesService } from '../../../../core/api/services/sms-templates.service';
import { UtilityService } from '../../../../core/services/utility.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';

@Component({
    selector: 'app-sms-template-form',
    templateUrl: './sms-template-form.component.html',
    styleUrls: ['./sms-template-form.component.scss'],
    imports: [BaseFormModule, ModalTitleComponent]
})
export class SmsTemplateFormComponent
  extends BaseFormPageComponent
  implements OnInit, AfterViewInit
{
  //#region Properties
  title: string;
  model: GetSmsTemplateByIdDto = {};
  formPageConfig: FormPageConfig<GetSmsTemplateByIdDto> = {};
  parentId: number;
  smsLength: any;
  smsCount: number;

  //#endregion

  constructor(
    protected currentService: SmsTemplatesService,
    public UtilityService: UtilityService,

    private dialogRef: MatDialogRef<SmsTemplateFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    this.formPageConfig.editId = data?.id;
    if (data.model) this.model = data?.model;
    this.parentId = data?.parentId;
  }

  ngOnInit() {
    try {
      this.initForm();
      if (this.parentId) this.model.smsTemplateGroupId = this.parentId;
      this.getSmsCount();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl(this.model.title, Validators.required),
      body: new FormControl(this.model.body, Validators.required),
      smsTemplateGroupId: new FormControl(
        this.model.smsTemplateGroupId,
        Validators.required
      ),
    });
  }

  //#region Api

  //Create
  baseCreateApi(model: CreateSmsTemplateCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .smsTemplatesCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateSmsTemplateCommand) {
    this.unSubs();
    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .smsTemplatesUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region final methods

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.unSubs();
    this.dialogRef.close(true);
  }

  //#endregion

  getSmsCount() {
    this.smsLength = this.model.body?.length;
    const result = this.UtilityService.getSmsPart(this.model.body, 3);
    this.smsCount = result.smsPart;
  }
}
